import React, { PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

const NoOfClaimsInPast3Years = (props) => {
  return (
    <FormGroup>
      <Col componentClass={ControlLabel} sm={5}>
        Number of Claims in past 3 years *
      </Col>
      <Col sm={7}>
            <select
              className="custom-select"
              name="noOfClaimsInPast3Years"
              value={props.noOfClaimsInPast3Years}
              onChange={props.handleChangeNoOfClaimsInPast3Years}
              required={props.required}
              disabled={props.disabled}
              onBlur={() => props.validation(true)}
            >
              <option value="">Please select</option>
              <option value="0">0</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5+</option>
            </select>
      </Col>
    </FormGroup>
  )
}

NoOfClaimsInPast3Years.propTypes = {
  noOfClaimsInPast3Years: PropTypes.number,
  handleChangeNoOfClaimsInPast3Years: PropTypes.func,
  required: PropTypes.bool,
  validation: PropTypes.func,
  disabled: PropTypes.bool
};

NoOfClaimsInPast3Years.defaultProps = {
  disabled: false,
  required: false
};

export default NoOfClaimsInPast3Years;



// WEBPACK FOOTER //
// ./src/app/components/noOfClaimsInPast3Years/NoOfClaimsInPast3Years.js